import { render, staticRenderFns } from "./UpgradeInterface.vue?vue&type=template&id=70e088e3&"
import script from "./UpgradeInterface.vue?vue&type=script&lang=js&"
export * from "./UpgradeInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports